{
  "accounts": {
    "current": "You’re currently using the following account: {{name}}",
    "signed_in": "You’re currently signed in as {{email}}",
    "switch_to": "Switch to"
  },
  "error_page": {
    "403": {
      "description": "You do not have permission to access this page.",
      "title": "403: Forbidden"
    },
    "404": {
      "description": "The page you are looking for could not be found.",
      "title": "404: Page Not Found"
    },
    "422": {
      "description": "Your request could not be processed. Please reload the page and try again.",
      "title": "422: Unprocessable Request"
    },
    "500": {
      "description": "An unexpected error occurred. Please try again later.",
      "title": "500: Server Error"
    },
    "503": {
      "description": "The service is temporarily unavailable due to maintenance. Please try again shortly.",
      "title": "503: Service Unavailable"
    },
    "default": {
      "description": "An error occurred while processing your request. Please try again later.",
      "title": "Error {{status}}"
    }
  },
  "navigation": {
    "home": "Home",
    "sign_out": "Sign out"
  },
  "passwords": {
    "back_to_login": "Back to sign in",
    "request": {
      "description": "Enter your email address and we’ll send you reset instructions.",
      "submit": "Send instructions",
      "title": "Forgot your password?"
    },
    "reset": {
      "description": "Choose a new password for your account.",
      "password": "New password",
      "password_confirmation": "Confirm new password",
      "submit": "Reset password",
      "title": "Reset your password"
    }
  },
  "session": {
    "description": "Sign in with your email address and password.",
    "email_address": "Email address",
    "forgot_password": "Forgot password?",
    "have_invite_code": "Have an invite code?",
    "password": "Password",
    "sign_up": "Sign up",
    "submit": "Sign in",
    "title": "Sign in"
  },
  "signup": {
    "back_to_login": "Back to sign in",
    "code": "Invite code",
    "description": "Enter your invite code to create an account.",
    "email_address": "Email address",
    "first_name": "First name",
    "last_name": "Last name",
    "password": "Password",
    "password_confirmation": "Confirm password",
    "submit": "Create account",
    "title": "Create your account"
  },
  "attributes": {
    "created_at": "Created",
    "discarded_at": "Deleted"
  }
}
